import { LatestPostsSlider } from '../../../js/src/__utils/sliders';
const slider = document.querySelector(LatestPostsSlider.selector);

// GLOBAL APP CONTROLLER
const controller = {
  init() {
    LatestPostsSlider.init();
  },
  loaded() {},
  resized() {
    if (window.matchMedia(`(max-width: 991px)`).matches && !slider.classList.contains('slick-initialized')) {
      LatestPostsSlider.init();
    }
  },
  scrolled() {},
  keyDown(e) {},
  mouseUp(e) {},
};
export default controller;
